import { render, staticRenderFns } from "./DeleteHistoricoTempo.vue?vue&type=template&id=ecb89770"
import script from "./DeleteHistoricoTempo.vue?vue&type=script&lang=js"
export * from "./DeleteHistoricoTempo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports